import { render, staticRenderFns } from "./historicalSituationPieChartTwo.vue?vue&type=template&id=4fb04aab&scoped=true"
import script from "./historicalSituationPieChartTwo.vue?vue&type=script&lang=js"
export * from "./historicalSituationPieChartTwo.vue?vue&type=script&lang=js"
import style0 from "./historicalSituationPieChartTwo.vue?vue&type=style&index=0&id=4fb04aab&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb04aab",
  null
  
)

export default component.exports